import {
  Component,
  h,
  Prop,
  ComponentInterface,
  State,
  Watch,
} from '@stencil/core';
import { EfficiencyDisplay, EfficiencyModel } from './types';
import { Maybe } from '../../global/types';
import { getModel } from './api/getModel';

@Component({
  tag: 'efficiency-view',
  styleUrl: 'efficiency-view.scss',
  shadow: true,
})
export class EfficiencyView implements ComponentInterface {
  @Prop({
    attribute: 'data-url',
  })
    url: Maybe<string>;

  @Prop({
    attribute: 'data-display',
  })
    display: EfficiencyDisplay;

  @Prop({
    attribute: 'data-locale',
  })
    locale: string;

  @Prop({
    attribute: 'data-show',
  })
    show = true;

  @Watch('url')
  handlePropChange() {
    this.getModel(this.url);
  }

  /**
   * Method to retrieve product url from product id (it is a workaround backend not sending product url)
   */
  @Prop()
    getProductUrlById: (id: string) => Promise<string> = () => null;

  @State() loading = false;
  @State() model: Maybe<EfficiencyModel>;

  private cancel: Maybe<(message: any) => any>;

  connectedCallback() {
    this.getModel(this.url);
  }

  cancelRequest(msg = '') {
    if (this.cancel) {
      this.cancel(msg);
    }
  }

  disconnectedCallback() {
    this.cancelRequest('Component disconnected');
  }

  async getModel(url: string) {
    if (!url) {
      this.model = undefined;
      return;
    }
    try {
      this.model = undefined;
      setTimeout(() => {
        this.loading = true;
      }, 0);
      this.cancelRequest('Model url is outdated');
      this.model = await getModel(
        url,
        (c) => {
          this.cancel = c;
        },
        this.getProductUrlById,
      );
    } catch (e) {
      // silent error
    } finally {
      this.loading = false;
      this.cancel = undefined;
    }
  }

  render() {
    if (!this.show) {
      return null;
    }
    if (this.loading) {
      return <rt-loader></rt-loader>;
    }
    if (this.model) {
      return (
        <rt-efficiency
          model={this.model}
          display={this.display}
          locale={this.locale}
        ></rt-efficiency>
      );
    }
    return <rt-error-placeholder></rt-error-placeholder>;
  }
}
